// Mock data for Ruken Alazdehar General Trading LLC website

export const company = {
  name: "Ruken Alazdehar",
  fullName: "Ruken Alazdehar General Trading LLC",
  tagline: "Global Network — Local Delivery.",
  shortPitch: "The global trading house for strategic sourcing and distribution of industrial raw materials.",
  address: "Business Village A, Office No. 658, Port Saeed, Al Maktoum Road, Dubai, UAE · P.O. Box: 186885",
  phone: "+971 56 3898675",
  landline: "+971 4 376 4958",
  email: "info@rukenalazdehar.ae",
  hours: "Mon–Fri 9:00–18:00 · Closed on weekends",
  established: "Dubai, UAE · Operating since 2020",
  socials: {
    facebook: "#",
    twitter: "#",
    instagram: "#",
    youtube: "#",
    linkedin: "#",
  },
};

// Country code → readable name (used for origin chips + inline captions)
export const COUNTRY_NAMES = {
  AE: "UAE",
  OM: "Oman",
  CN: "China",
  VN: "Vietnam",
  ID: "Indonesia",
  IN: "India",
  BD: "Bangladesh",
  SA: "Saudi Arabia",
  QA: "Qatar",
  KW: "Kuwait",
  BH: "Bahrain",
  IR: "Iran",
  PK: "Pakistan",
  US: "USA",
  RU: "Russia",
  ZA: "South Africa",
  AU: "Australia",
};

export const navLinks = [
  {
    label: "Home",
    to: "/",
    children: [
      { label: "At a Glance", to: "/#glance" },
      { label: "About Us", to: "/about-us#about" },
      { label: "Who We Are", to: "/about-us#who" },
      { label: "What We Do", to: "/about-us#what" },
      { label: "Our Values", to: "/about-us#value" },
      { label: "Our Mission", to: "/about-us#mission" },
      { label: "Our Vision", to: "/about-us#mission" },
    ],
  },
  { label: "About Us", to: "/about-us" },
  {
    label: "Commodities",
    to: "/product-categories",
    children: [
      {
        label: "Cement Raw Material",
        to: "/products/category-a-cement-raw-material-products",
        submenu: [
          { label: "Clinker", to: "/products/category-a-cement-raw-material-products#Clinker" },
          { label: "Limestone (Cement & Construction Grade)", to: "/products/category-a-cement-raw-material-products#" + encodeURIComponent("Limestone (Cement & Construction Grade)") },
          { label: "Gypsum", to: "/products/category-a-cement-raw-material-products#Gypsum" },
          { label: "Slag (GBFS / GGBFS)", to: "/products/category-a-cement-raw-material-products#" + encodeURIComponent("Slag (GBFS / GGBFS)") },
          { label: "Fly Ash", to: "/products/category-a-cement-raw-material-products#Fly Ash" },
          { label: "Construction Aggregates", to: "/products/category-a-cement-raw-material-products#" + encodeURIComponent("Construction Aggregates") },
        ],
      },
      { label: "Coal", to: "/products/category-b-coal" },
      {
        label: "Petroleum Products",
        to: "/products/category-f-petroleum-products",
        submenu: [
          { label: "Bitumen", to: "/products/category-f-petroleum-products#" + encodeURIComponent("Bitumen (Petroleum Asphalt Cement)") },
          { label: "Commodity Plastic Resin", to: "/products/commodity-plastic-resin" },
        ],
      },
    ],
  },
  { label: "Contact", to: "/contact-us" },
];

// News section — set to true to re-enable across site (menu, footer, homepage strip, /news route)
export const NEWS_ENABLED = false;

// Hidden categories (kept in data, filtered out from UI)
export const HIDDEN_CATEGORIES = [
  "category-c-minerals",
  "category-d-chemicals",
  "category-e-washing-chemicals",
];

// ---- About / Who We Are ----
export const aboutContent = {
  aboutHeadline: "Global Network — Local Delivery",
  aboutIntro:
    "At Ruken Alazdehar General Trading LLC, we are a global trading house specialising in the strategic sourcing and global distribution of industrial raw materials. We act as a vital link between major mineral producers and the world's leading raw material manufacturers — ensuring that local manufacturers receive a continuous, uninterrupted flow of heavy industrial materials.",
  aboutIntro2:
    "From sourcing to delivery, we manage the entire supply chain with absolute precision, competitive pricing, and strict quality control.",
  whoHeadline: "A Global Network Built on Local Reliability",
  whoBody:
    "Based in Dubai, UAE, Ruken Alazdehar General Trading LLC has been operating since 2020 — delivering high-volume, quality-tested bulk materials with absolute transparency. Along our journey, we have successfully developed a large, loyal client base.",
  whoBody2:
    "As a trusted international trading partner, we streamline the complexities of global logistics through high-volume sourcing, international maritime logistics and reliable delivery of critical cementitious raw materials.",
  mission:
    "Our mission is to add value to global trade and logistics through innovative solutions while maintaining the highest ethical practices. We are committed to serving our business partners with world-class services and uncompromised product quality that drive meaningful impact for society.",
  vision:
    "To be the most trusted and responsible trading partner for each of our buyers and suppliers across the world — through unyielding ethical integrity, elite service and a lasting positive impact on society.",
};

// ---- "Ruken At A Glance" — Homepage (replaces the About-teaser overlap) ----
export const glanceContent = {
  overline: "Overview",
  headline: "Ruken At A Glance",
  subheadline: "Driving Industrial Growth Through Precision Sourcing and Global Logistics.",
  p1: "Ruken Alazdehar manages a massive, optimized global supply chain for industrial raw materials. Distributing millions of tons of commodities—including Clinker, Limestone, Gypsum, and Slag—we connect major producers directly with leading manufacturers. Our robust logistics network and rigorous quality testing ensure uninterrupted, cost-efficient material flows worldwide.",
  image: "/images/ruken-glance.webp",
};

// ---- Why Partners Choose Us (About page) ----
export const partnerReasons = [
  {
    icon: "ShieldCheck",
    title: "Supply Chain Resilience",
    body:
      "We absorb market volatility and eliminate logistics bottlenecks to keep your production lines moving without interruption.",
  },
  {
    icon: "Globe2",
    title: "Global Sourcing Network",
    body:
      "We maintain direct relationships with strategic extraction sites and industrial producers worldwide.",
  },
  {
    icon: "Ship",
    title: "End-to-End Maritime Logistics",
    body:
      "From port-to-port chartering to strict quality control, we manage the complexities of bulk dry cargo.",
  },
];

// ---- What We Do (three pillars) ----
export const whatWeDoIntro =
  "We do global sourcing deep-rooted origination points in the world's most resource-rich manufacturing hubs and it primarily involves strict due diligence by our experts by visit to supplying factories, mines and quarries, ports to ensure only best quality commodity and purchased from best producers with best vessel loading logistics solutions to make timely delivery to our clients. Our core operations are built on the following pillars:";

export const services = [
  {
    icon: "Globe2",
    title: "Global Strategic Sourcing",
    body:
      "We source high-grade Clinker, Limestone, Slag, and Gypsum through exclusive partnerships with premier producers in Vietnam, Indonesia, China, and the Middle East.",
  },
  {
    icon: "Ship",
    title: "Bulk Maritime Logistics",
    body:
      "By optimizing maritime routes, our efficient chartering team manages Panamax, Supramax and Handymax to ensure timely arrival at the destination ports.",
  },
  {
    icon: "ShieldCheck",
    title: "Rigorous Quality Assurance",
    body:
      "With direct one-to-one connection with sourcing points, we regularly visit and also appoint third-party surveyors (such as SGS or Bureau Veritas) at loading ports to guarantee all minerals strictly comply with BDS EN and international standards.",
  },
];

// ---- Seven Pillars (How We Add Value) ----
export const strengths = [
  {
    icon: "Clock",
    title: "On-time Delivery",
    image: "/images/pillar-low-turnaround.webp",
    body:
      "We serve multiple global clients as their networking partners to source the best fit against their industrial raw material requirements. We believe, our business succeeds on shared achievement; each partnership expands our expertise and fuels our mutual growth. Our approach prioritizes their success through rapid, proactive decision-making that actively protects their commercial interests. This unwavering commitment forms the cornerstone of our reputation as a highly reliable global trading firm.",
  },
  {
    icon: "BadgePercent",
    title: "Competitive Deals",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85",
    body:
      "Exceptional supply chain integration drives our reputation as a premier global destination for industrial raw material procurement. We excel in structuring highly competitive trade deals, supplying premium industrial inputs to our network of global partners. Our unified trading platform empowers clients to seamlessly acquire top-notch resources at optimized price points, delivering exceptional value that fuels their corporate growth.",
  },
  {
    icon: "Factory",
    title: "Manufacturer-sourced Excellence",
    image: "/images/pillar-manufacturer-excellence.webp",
    body:
      "Our highly secure trading platform facilitates essential procurement and sourcing directly from tier-one manufacturers and certified vendors worldwide. We deliver industrial products that guarantee premium quality and the highest benchmarks of customer satisfaction. By partnering exclusively with verified producers, we continuously cultivate institutional trust and long-term client loyalty across the global supply chain.",
  },
  {
    icon: "Handshake",
    title: "Consistent Services",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?crop=entropy&cs=srgb&fm=jpg&q=85",
    body:
      "Reliability and exceptional care define the experience of every international partner who chooses Ruken Alazdehar for their industrial raw material procurement. Moving far beyond the role of standard trade facilitators, we dedicate ourselves entirely to delivering on our promise of uncompromised quality. We anchor our daily operations upon an efficient framework that guarantees thorough professionalism, clear accountability, and seamless, transparent communication at every touchpoint.",
  },
  {
    icon: "Zap",
    title: "Low Turnaround Time",
    image: "/images/pillar-on-time-delivery.webp",
    body:
      "Speed and punctuality are central to the operations at Ruken Alazdehar, allowing our international partners to maintain a definitive competitive edge in the industrial raw material sector. We recognize that market demands change rapidly, which is why our streamlined logistical schedules are designed to provide well-timed, agile responses to every requirement. This dedication to low turnaround times not only enhances overall productivity and supply efficiency but also ensures that every structured deal results in a clear win-win outcome for everyone involved.",
  },
  {
    icon: "Map",
    title: "Expert Logistic Management",
    image: "/images/bulk-carrier-loading.webp",
    body:
      "Seamless movement and operational precision define how Ruken Alazdehar navigates the complexities of global shipping and strategic raw material distribution. Our specialized on-site teams maintain a sharp, continuous focus on assigned ports, managing transshipment, custom clearances, and multimodal transport with absolute efficiency. By transforming logistics from a challenge into a core strength, we optimize both resources and time, empowering our partners to confidently embrace new market opportunities and global demands.",
  },
  {
    icon: "Users",
    title: "Customer Solutions",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85",
    body:
      "With deep understanding of each product we trade, we do global sourcing involving strict due diligence by our experts by visit to supplying factories, mines and quarries, ports to ensure only best quality commodity and purchased from best producers with best vessel loading logistics solutions to make timely deliver exactly what each of our customers requires. By nurturing meaningful, one-to-one relationships with our customers, we instinctively anticipate their evolving needs, deliver highly adaptable solutions, and directly fuel their long-term corporate growth.",
  },
];

// ---- Stats (Ruken At A Glance — 4 key metrics + others) ----
export const glanceStats = [
  { value: 10, suffix: "+", label: "Active Countries", icon: "Globe2", key: "activeCountries" },
  { value: 4.5, suffix: "M+", label: "Tons Transported / Annum", icon: "Ship" },
  { value: 6, suffix: " Years", label: "Of Industry Experience", icon: "Clock" },
  { value: 8, suffix: "%", label: "Annual Growth Rate", icon: "BarChart3" },
];

export const stats = [
  { value: 214, suffix: "M", prefix: "$", label: "Total Volume" },
  { value: 4.5, suffix: "M+ Ton", label: "Goods Transported / Annum" },
  { value: 24, label: "Shipments / Year" },
  { value: 32, label: "Nationalities" },
  { value: 24, suffix: "/5", label: "Operations Availability" },
  { value: 3, label: "Active Regions" },
  { value: 10, suffix: "+", label: "Active Countries", key: "activeCountries" },
  { value: 30, label: "Product Varieties" },
];

// Active countries breakdown (used in the modal triggered by the counter)
export const activeCountries = [
  "Vietnam", "Indonesia", "China", "United Arab Emirates", "Oman",
  "Pakistan", "Thailand", "Saudi Arabia", "Japan", "South Korea",
];

// ---- Hero Carousel Slides ----
export const heroSlides = [
  {
    image: "/images/hero-1.webp",
    kicker: "Dubai · Global Trading Since Day One",
    title: "Global Network. Local Delivery.",
    highlight: "Local Delivery.",
    subtitle: "A global trading house for strategic sourcing and distribution of industrial raw materials — a vital link between major mineral producers and the world's leading manufacturers.",
  },
  {
    image: "/images/hero-2.webp",
    kicker: "Bulk Maritime Logistics",
    title: "Panamax · Supramax · Handymax — On Schedule.",
    highlight: "On Schedule.",
    subtitle: "Optimising maritime routes with an efficient chartering team, delivering millions of tons of bulk commodities to destination ports on time.",
  },
  {
    image: "/images/hero-3.webp",
    kicker: "Cement Raw Materials",
    title: "Clinker · Limestone · Gypsum · Slag.",
    highlight: "Gypsum · Slag.",
    subtitle: "Exclusive partnerships with premier producers from Vietnam, Indonesia, China and the Middle East — meeting BDS EN and international standards.",
  },
];

// ---- Categories & Products ----
export const categories = [
  {
    slug: "category-a-cement-raw-material-products",
    code: "A",
    title: "Cement Raw Material Products",
    short: "Clinker, limestone, gypsum, slag, Fly Ash, aggregates and cement.",
    image:
      "https://images.unsplash.com/photo-1666219462105-2909c2d72d01?crop=entropy&cs=srgb&fm=jpg&q=85",
    products: [
      {
        name: "Clinker",
        spec: "PORTLAND CEMENT CLINKER · STANDARD INDUSTRIAL GRADE",
        export: "China · Vietnam · Indonesia origins",
        body:
          "Supplying top-quality Clinker with a consistent quality record. Ruken Alazdehar has extensive relationships with large cement groups of China, Vietnam and Indonesia — regularly supplying Clinker into the Bangladesh market and beyond. Based on your customised requirements, we can source and supply special Clinker grades.",
        image: "/images/clinker-new.jpeg",
        specSheet: "/specs/Ruken-Clinker-Specifications.pdf",
        highlights: [
          "China · Vietnam · Indonesia",
          "Consistent quality record",
          "Customisable to buyer spec",
          "Direct large cement-group sourcing",
        ],
        origins: ["CN", "VN", "ID"],
        specs: [
          { p: "Silicon Dioxide", c: "SiO₂", r: "20.00 ~ 22.00" },
          { p: "Aluminium Oxide", c: "Al₂O₃", r: "4.50 ~ 6.00" },
          { p: "Ferric Oxide", c: "Fe₂O₃", r: "3.00 ~ 4.00" },
          { p: "Calcium Oxide", c: "CaO", r: "Min. 65" },
          { p: "Magnesium Oxide", c: "MgO", r: "≤ 2.0" },
          { p: "Sulfur Trioxide", c: "SO₃", r: "≤ 1.0" },
          { p: "Loss on Ignition", c: "LOI", r: "≤ 0.5" },
          { p: "Insoluble Residue", c: "IR", r: "≤ 0.5" },
          { p: "Moisture", c: "%", r: "Nil" },
          { p: "Free Lime", c: "F/CaO", r: "≤ 1.5" },
          { p: "Tricalcium Silicate", c: "C₃S", r: "≥ 58" },
          { p: "Dicalcium Silicate", c: "C₂S", r: "≤ 20" },
          { p: "Tricalcium Aluminate", c: "C₃A", r: "≤ 9" },
          { p: "Tetracalcium Ferrite", c: "C₄AF", r: "—" },
          { p: "Lime Saturation Factor", c: "LSF", r: "92.00 ~ 97.00" },
          { p: "Chloride", c: "Cl⁻", r: "≤ 0.01" },
          { p: "Total Alkalis", c: "Na₂O + 0.658 K₂O", r: "≤ 0.60" },
          { p: "Colour", c: "—", r: "Dark Grey" },
          { p: "Size — Above 25mm", c: "%", r: "Max 5" },
          { p: "Size — 1mm to 25mm", c: "%", r: "Max 65" },
          { p: "Size — Below 1mm", c: "%", r: "Max 30" },
        ],
      },
      {
        name: "Limestone (Cement & Construction Grade)",
        spec: "CEMENT & CONSTRUCTION GRADE · SIZED 5–10mm / 10–20mm",
        export: "UAE · Oman origins",
        body:
          "Supplying top-quality Limestone with a consistent quality record. We supply huge quantities of Limestone from UAE and Oman to Bangladesh on a regular basis. Construction-grade sizes (5–10mm, 10–20mm) available as per buyer's requirements. Custom sourcing available for special specifications.",
        image: "/images/limestone-updated.jpeg",
        specSheet: "/specs/Ruken-Limestone-Specifications.pdf",
        origins: ["AE", "OM"],
        highlights: [
          "UAE & Oman origin",
          "Cement & construction grade",
          "Construction sizes: 5–10mm & 10–20mm",
          "Purity min. 96%",
        ],
        specs: [
          { p: "Calcium Oxide", c: "CaO", r: "52.0" },
          { p: "Silica Content", c: "SiO₂", r: "Max: 2.00" },
          { p: "Alumina + Iron", c: "Al₂O₃ + Fe₂O₃", r: "Max: 1.0" },
          { p: "Magnesium Oxide", c: "MgO", r: "Max: 1.0" },
          { p: "Loss on Ignition", c: "LOI", r: "Min: 42.0" },
          { p: "Purity", c: "%", r: "Min: 96.0" },
          { p: "Moisture", c: "%", r: "Max: 1.0" },
          { p: "Bulk Density", c: "t/m³", r: "Min: 1.30" },
        ],
      },
      {
        name: "Gypsum",
        spec: "NATURAL GYPSUM · SO₃ MIN. 43% · PURITY MIN. 91%",
        export: "Highest-purity natural gypsum",
        body:
          "Experience the unmatched purity and finest quality with our premium natural gypsum. Cement retarder, plasterboard and agricultural grades available. Based on customised requirements, we can source and supply special grades.",
        image: "/images/gypsum-1.jpeg",
        specSheet: "/specs/Ruken-Gypsum-Specifications.pdf",
        origins: ["OM", "IR"],
        gallery: ["/images/gypsum-1.jpeg", "/images/gypsum-2.jpeg"],
        highlights: [
          "Cement retarder grade",
          "Plasterboard grade",
          "Agricultural grade",
          "ASTM C 471-94 compliant",
        ],
        specs: [
          { p: "Silica", c: "SiO₂", r: "Max 2.0" },
          { p: "Total Sulfate", c: "SO₃", r: "Min 43.0" },
          { p: "Moisture", c: "%", r: "Max 2.0" },
          { p: "Purity (combined water, ASTM C 471-94)", c: "CaSO₄·2H₂O", r: "Min 91.0" },
          { p: "Sieve Size", c: "%", r: "Max 5.0" },
        ],
      },
      {
        name: "Slag (GBFS / GGBFS)",
        spec: "GBFS / GGBFS · CEMENT ADDITIVE",
        export: "Blast-furnace sourced · Sustainable clinker substitute",
        body:
          "Sourced directly from premier blast-furnace operations, our Slag is a high-grade, non-metallic by-product engineered as a premium, sustainable cement additive and clinker substitute. Available as Granulated Blast Furnace Slag (GBFS — Slag Granules) and Ground Granulated Blast Furnace Slag (GGBFS — Slag Powder), it features excellent latent hydraulic and binding properties that significantly enhance the ultimate strength and longevity of concrete.\n\nIncorporating Ruken's Slag into cement production drastically optimizes the material's structural integrity, increases resistance to aggressive chemical attacks (such as sulfates and chlorides), and improves long-term durability while actively reducing the carbon footprint. It stands as an eco-friendly and cost-effective raw material baseline, trusted by industry leaders for sustainable, high-volume manufacturing, infrastructure development, and structural concrete production.",
        image: "/images/product-slag.webp",
        highlights: [
          "GBFS (Granules) & GGBFS (Powder)",
          "Latent hydraulic binding properties",
          "Sulfate & chloride resistance",
          "Reduces carbon footprint",
        ],
        specsColumns: ["#", "Test Item / Chemical Symbol", "Unit", "Test Result", "Standard No."],
        specs: [
          { p: "Ferric Oxide", c: "Fe₂O₃", u: "%", r: "1.00", s: "BS EN 196-2:2013(E)" },
          { p: "Silicon Dioxide", c: "SiO₂", u: "%", r: "33.57", s: "BS EN 196-2:2013(E)" },
          { p: "Aluminium Oxide", c: "Al₂O₃", u: "%", r: "14.46", s: "BS EN 196-2:2013(E)" },
          { p: "Calcium Oxide", c: "CaO", u: "%", r: "40.09", s: "BS EN 196-2:2013(E)" },
          { p: "Magnesium Oxide", c: "MgO", u: "%", r: "7.94", s: "BS EN 196-2:2013(E)" },
          { p: "Titanium Dioxide", c: "TiO₂", u: "%", r: "1.43", s: "BS EN 196-2:2013(E)" },
          { p: "Chloride", c: "Cl⁻", u: "%", r: "0.016", s: "BS EN 196-2:2013(E)" },
          { p: "Sulfur Trioxide", c: "SO₃", u: "%", r: "0.16", s: "BS EN 196-2:2013(E)" },
          { p: "Manganese Oxide", c: "MnO", u: "%", r: "0.25", s: "BS EN 196-2:2013(E)" },
          { p: "Glass Content", c: "—", u: "%", r: "99.7", s: "GB/T 203-2008" },
          { p: "Moisture", c: "—", u: "%", r: "5.97", s: "GB/T 18046-2017" },
        ],
      },
      {
        name: "Fly Ash",
        spec: "CLASS F / CLASS C · POZZOLANIC",
        export: "Sustainable clinker alternative",
        body:
          "Fly Ash is a highly consistent, fine powder by-product captured from pulverized coal combustion in electric power generation plants. Widely recognized as a premium pozzolanic material, it reacts chemically with lime and water to form a compound structurally similar to Portland cement, significantly enhancing the ultimate strength and durability of concrete structures.\n\nAs a high-grade, sustainable alternative to clinker, incorporating Ruken's Fly Ash into cement production drastically reduces carbon dioxide (CO₂) emissions while improving long-term structural integrity. It optimizes concrete workability, minimizes water demand, and offers exceptional resistance against aggressive chemical attacks — making it an essential raw material for sustainable, high-volume industrial infrastructure projects.",
        image: "https://images.pexels.com/photos/4750320/pexels-photo-4750320.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        highlights: [
          "Class F & Class C pozzolanic",
          "Reduces CO₂ emissions",
          "Improves durability & workability",
          "Sustainable clinker alternative",
        ],
      },
      {
        name: "Construction Aggregates",
        spec: "CRUSHED STONE · AGGREGATES",
        export: "High-density infrastructure grade",
        body:
          "Engineered for maximum structural integrity, Ruken supplies premium-grade crushed stone and high-density aggregates tailored strictly for the heavy construction, infrastructure, and landscaping industries. Widely recognized for its exceptional load-bearing strength and durability, our aggregates and rock armor solutions are sourced from reliable regional formations to meet rigid project specifications and high-volume demand.\n\nWe offer end-to-end capabilities for bulk vessel loading, delivering consistent quality control across a versatile range of industry-standard sizing. Our prime construction aggregate baselines are highly optimized for robust infrastructure projects and come systematically graded in the following operational size matrix:",
        image: "/images/product-gabbro.jpg",
        specSheet: "/specs/Ruken-Gabbro-Aggregates-Specifications.pdf",
        highlights: [
          "0–5mm (High-Fineness Construction Sand)",
          "5–10mm · 10–20mm",
          "20–30mm · 20–40mm",
          "40–60mm (Heavy Aggregates & Base Course)",
        ],
        specsColumns: ["#", "Physical / Mechanical Property", "Test Method", "Typical Value"],
        specs: [
          { p: "Specific Gravity (Apparent)", c: "BS EN 1097-6 / ASTM C127", r: "2.85–2.95 g/cm³" },
          { p: "Water Absorption", c: "BS EN 1097-6 / ASTM C127", r: "< 0.60%" },
          { p: "Los Angeles Abrasion Value (LAAV)", c: "BS EN 1097-2 / ASTM C131", r: "12–16%" },
          { p: "Aggregate Crushing Value (ACV)", c: "BS 812:Part 110", r: "14–18%" },
          { p: "Flakiness Index (FI)", c: "BS EN 933-3 / ASTM D4791", r: "< 15%" },
          { p: "Elongation Index (EI)", c: "BS EN 933-3 / ASTM D4791", r: "< 20%" },
          { p: "Soundness (Magnesium Sulfate Loss)", c: "BS EN 1367-2 / ASTM C88", r: "< 2.0%" },
          { p: "Clay Lumps & Friable Particles", c: "ASTM C142", r: "< 0.25%" },
        ],
      },
    ],
  },
  {
    slug: "category-b-coal",
    code: "B",
    title: "Coal",
    short:
      "High-Performance Coal for Power Generation & Heavy Industry.",
    image: "/images/coal-new.webp",
    intro:
      "Keep your operations running at peak efficiency with reliable, top-tier coal from Ruken Alazdehar General Trading LLC. We source directly from trusted mining partners to deliver consistent fuel quality for heavy industry, cement, steel, and thermal power plants.",
    products: [
      {
        name: "Coal",
        spec: "HIGH-PERFORMANCE COAL · POWER & HEAVY INDUSTRY",
        export: "Indonesia · South Africa · Australia origins",
        body:
          "Powering global industries and energy sectors worldwide, Ruken manages a highly resilient supply chain for high-quality coal distribution. Operating with full legal documentation, certified quality assays, and reliable maritime logistics, we offer flexible commercial frameworks ready for FOB, CFR, or CIF delivery directly to your destination port.\n\nBacked by a global infrastructure, Ruken effectively mitigates market volatility, price, and quality risks for our institutional partners. Recognizing that industrial fuel specifications are constantly evolving, we deliver precisely graded coal baselines engineered to match our customers' distinct operational profiles and boiler criteria.",
        image: "/images/coal-new.webp",
        origins: ["ID", "ZA", "AU"],
        highlights: [
          "High Heat Output — excellent calorific value for maximum energy efficiency per shipment",
          "Responsible Sourcing — strong focus on compliance and environmental standards",
          "Versatile Grades — suited for specific industrial processes, kiln heating, or continuous power generation",
          "Dependable Supply Chain — on-time delivery scheduled around your operational timeline",
        ],
      },
    ],
  },
  {
    slug: "category-c-minerals",
    code: "C",
    title: "Minerals",
    short: "Aluminum, iron ore and bauxites for global metallurgical industries.",
    image:
      "https://images.pexels.com/photos/16207033/pexels-photo-16207033.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    products: [
      {
        name: "Aluminum",
        body:
          "An extremely versatile metal, recognised for being both lightweight and flexible, with numerous advantages across industries.",
      },
      {
        name: "Iron Ore",
        body:
          "In collaboration with our vendors we have established a trustworthy network of reliable products, offering technical support for optimal application and securing long-term agreements.",
      },
      {
        name: "Bauxites",
        body:
          "The primary aluminum ore, categorized into metallurgical, chemical or cement applications.",
      },
    ],
  },
  {
    slug: "category-d-chemicals",
    code: "D",
    title: "Chemicals",
    short: "Industrial chemicals for dyeing, manufacturing and processing.",
    image:
      "https://images.unsplash.com/photo-1620203853151-496c7228306c?crop=entropy&cs=srgb&fm=jpg&q=85",
    products: [
      { name: "Sulphuric acid (H₂SO₄)", body: "Used to manufacture dyes, glue, wood preservatives and automobile batteries." },
      { name: "Hydrogen peroxide (H₂O₂)", body: "The bleaching agent of choice for treating natural and synthetic fibers such as cotton, wool, rayon, silk, linen and viscose." },
      { name: "Methanol (CH₃OH)", body: "A dyeing medium for cotton fabric with reactive and direct dyes without using salt, soda or other auxiliary chemicals." },
      { name: "Calcium carbonate (CaCO₃)", body: "A dye assist / modifier in natural dyeing; chalk boosts colour uptake on Madder, Munjeet and Weld by creating less-acidic conditions." },
      { name: "Sulphur dioxide (SO₂)", body: "Sulfur dyes used mainly for textile cellulosic materials, or blends with synthetic fibers; limited silk and paper applications." },
      { name: "Sodium Chloride (NaCl)", body: "Salt acts as the glue holding dye molecules in cloth; used as an exhausting agent in textile dyeing with various colorants." },
    ],
  },
  {
    slug: "category-e-washing-chemicals",
    code: "E",
    title: "Industrial Laundry Chemicals",
    short: "Surfactants and laundry chemistry for industrial-scale washing.",
    image:
      "https://images.pexels.com/photos/615670/pexels-photo-615670.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    products: [
      {
        name: "Industrial Laundry Chemicals",
        body:
          "Laundry detergents, all-purpose cleaners and washing-up liquids all contain surfactants (surface-active materials). They reduce the surface tension between water and grease so the two can mix — letting water grip the grease and wash it away.",
      },
    ],
  },
  {
    slug: "category-f-petroleum-products",
    code: "F",
    title: "Petroleum Products",
    short: "Bitumen and commodity plastic resins for industrial packaging and infrastructure.",
    image: "/images/bitumen-2-new.jpeg",
    products: [
      {
        name: "Bitumen (Petroleum Asphalt Cement)",
        spec: "PENETRATION GRADE · ASTM D946 · AASHTO M20 · EN 12591",
        export: "United Arab Emirates origin",
        body:
          "Ruken Alazdehar General Trading LLC supplies premium-grade Bitumen sourced directly from UAE refineries, one of the world's most reliable and high-volume export hubs for petroleum-derived binders. Refined as the vacuum-distillation residue of crude petroleum, our Bitumen is processed under controlled thermal conditions to deliver a consistent, homogeneous product engineered for demanding infrastructure and industrial applications.\n\nLeveraging the same global sourcing network and port logistics infrastructure that supports our Clinker, Limestone, Natural Gypsum, and Slag trade lines, we move Bitumen at scale from UAE terminals to manufacturing plants, contractors, and distributors worldwide — backed by uninterrupted supply, rigorous laboratory testing, and third-party quality inspection at every shipment stage.",
        image: "/images/bitumen-1-new.jpeg",
        gallery: ["/images/bitumen-1-new.jpeg", "/images/bitumen-2-new.jpeg"],
        origins: ["AE"],
        highlights: [
          "Road & Highway Construction (HMA)",
          "Airport Runway Paving",
          "Waterproofing & Roofing",
          "Industrial Coatings & Sealants",
        ],
        gradesTable: {
          title: "Grades Available",
          intro: "We supply Penetration Grade Bitumen across the full standard range, produced and blended to meet ASTM D946, AASHTO M20, and EN 12591 specifications:",
          note: "VG and PG performance grades available on request.",
          columns: ["Grade", "Typical Use"],
          rows: [
            ["40/50", "Hot climates, high-stiffness paving"],
            ["60/70", "Standard paving grade — most widely used globally"],
            ["80/100", "Moderate to cold climates, flexible pavements"],
            ["180/220", "Surface dressing, low-temperature applications"],
          ],
        },
        packaging: [
          "New steel drums — 150 kg, 180 kg, or 225 kg net weight",
          "Jumbo bags (bulk packaging)",
          "Flexitanks and bulk tanker shipment for large-volume orders",
          "All drums are marked with grade, batch/lot number, and net weight for full traceability",
        ],
        qualityAssurance:
          "Every consignment is tested at accredited laboratories prior to shipment and is available with third-party inspection certification (SGS or equivalent) covering penetration, softening point, and purity parameters — ensuring full compliance with international standards and consistent, cargo-to-cargo product uniformity.",
        specsFooter:
          "Values conform to ASTM D946, AASHTO M20, and EN 12591 standards. Certificates of Analysis and third-party inspection reports available on request per shipment.",
        specsColumns: ["#", "Parameter", "Test Method", "Specification"],
        specs: [
          { p: "Penetration @ 25°C, 100g, 5sec (0.1mm)", c: "ASTM D5 / EN 1426", r: "60–70" },
          { p: "Softening Point (Ring & Ball)", c: "ASTM D36 / EN 1427", r: "49°C – 56°C" },
          { p: "Ductility @ 25°C", c: "ASTM D113", r: "100 cm min" },
          { p: "Flash Point (Cleveland Open Cup)", c: "ASTM D92", r: "250°C min" },
          { p: "Loss on Heating (Thin Film Oven Test)", c: "ASTM D1754", r: "0.8% max" },
          { p: "Retained Penetration after TFOT", c: "ASTM D5", r: "50% min" },
          { p: "Solubility in Trichloroethylene", c: "ASTM D2042", r: "99% min" },
          { p: "Specific Gravity @ 25/25°C", c: "ASTM D70", r: "1.01 – 1.06" },
          { p: "Ash Content", c: "ASTM D482", r: "1% max" },
          { p: "Water Content", c: "ASTM D95", r: "0.2% max" },
        ],
      },
      {
        name: "Commodity Plastic Resin",
        spec: "PP · HDPE · LDPE · PS · PET · PVC · EVA",
        body:
          "Ruken supplies commodity plastic resins across the full range of standard-grade thermoplastics — sourced directly from major petrochemical producers and shipped in bulk to converters, molders, extruders and packaging manufacturers worldwide. Grades and specifications customisable to buyer requirements.",
        image: "/images/ppe-ldpe-rolls.webp",
        detailPage: "/products/commodity-plastic-resin",
      },
    ],
  },
];

// ---- Commodity Plastic Resin dedicated product page content ----
export const polymerContent = {
  title: "Commodity Plastic Resin",
  overline: "Petroleum Products",
  description:
    "A global trading house for the strategic sourcing and distribution of industrial raw materials — a vital link between the world's mineral producers and leading manufacturers.",
  intro:
    "Ruken Alazdehar supplies commodity plastic resins across the full range of standard-grade thermoplastics — Polypropylene (PP), High-Density Polyethylene (HDPE), Low-Density Polyethylene (LDPE), Polystyrene (PS), Polyethylene Terephthalate (PET), Polyvinyl Chloride (PVC) and Ethylene Vinyl Acetate (EVA). Every consignment is shipped with technical data sheets, certificates of analysis and full port-to-port logistics.",
  image: "/images/ppe-ldpe-rolls.webp",
  disclaimer:
    "Values shown are typical industry reference figures for a standard application grade, provided for general guidance only. Actual certificate-of-analysis data varies by grade, batch and supplier — contact us for the technical data sheet specific to the grade required.",
  polymers: [
    {
      code: "PP",
      name: "Polypropylene",
      description:
        "PP is a versatile, semi-crystalline thermoplastic offering high stiffness, good chemical resistance and low density relative to other commodity polymers. It is supplied across a range of application grades serving film, injection molding, fiber/filament, raffia (woven sack) and cement bag markets.",
      image: "/images/polymers/pp.webp",
      applications: [
        { app: "Film extrusion for flexible packaging, textile wrap and garment packaging", char: "High stiffness-to-weight ratio" },
        { app: "Injection molding for closures, houseware, crates, boxes and thin-walled containers", char: "Good chemical and heat resistance" },
        { app: "Fiber and continuous filament extrusion for high-denier yarns", char: "Excellent processability across extrusion and molding" },
        { app: "Raffia tape extrusion for woven sacks, woven fabrics and ropes", char: "Good tensile strength and dimensional stability" },
        { app: "—", char: "Good clarity in cast film grades" },
      ],
      physicalGroups: [
        {
          group: "Resin Properties (Raffia/Film Application Grade)",
          rows: [
            { property: "Melt Flow Rate", test: "ASTM D 1238 @ 230°C, 2.16 kg", value: "3.0", unit: "g/10 min" },
            { property: "Density", test: "ASTM D 1505", value: "0.905", unit: "g/cm³" },
            { property: "Melting Point", test: "ASTM D 3418", value: "165", unit: "°C" },
            { property: "Vicat Softening Point", test: "ASTM D 1525", value: "152", unit: "°C" },
          ],
        },
        {
          group: "Fiber / Tape Property",
          rows: [
            { property: "Tensile Strength (MD)", test: "ASTM D 638", value: "34", unit: "MPa" },
          ],
        },
      ],
      packaging: ["25 kg plastic bag"],
    },
    {
      code: "HDPE",
      name: "High-Density Polyethylene",
      description:
        "HDPE is a high-density polyethylene resin valued for its high strength-to-density ratio, stiffness and excellent chemical resistance. Its versatility across film, injection, blow molding and pipe extrusion processes makes it a preferred choice for durable, cost-efficient packaging and industrial products.",
      image: "/images/polymers/hdpe.webp",
      applications: [
        { app: "Film extrusion for high-strength grocery sacks, shopping bags and multi-wall liners", char: "High tensile strength and stiffness" },
        { app: "Injection molding for crates, trays, industrial pails, caps and closures", char: "Excellent environmental stress-crack resistance" },
        { app: "Blow molding for chemical containers, ice chests, coolers and shipping drums", char: "Good chemical and moisture resistance" },
        { app: "Pipe extrusion for water supply and gas distribution pipelines", char: "Good processability across multiple conversion methods" },
        { app: "—", char: "Good impact strength at low temperatures" },
      ],
      physicalGroups: [
        {
          group: "Resin Properties (Film Application Grade)",
          rows: [
            { property: "Melt Flow Rate", test: "ASTM D 1238 @ 190°C, 2.16 kg", value: "0.30", unit: "g/10 min" },
            { property: "Density", test: "ASTM D 1505", value: "0.952", unit: "g/cm³" },
            { property: "Melting Point", test: "ASTM D 2117", value: "130", unit: "°C" },
            { property: "Vicat Softening Point", test: "ASTM D 1525", value: "123", unit: "°C" },
          ],
        },
        {
          group: "Film Property",
          rows: [
            { property: "Dart Impact Strength", test: "ASTM D 1709", value: "90", unit: "g" },
          ],
        },
      ],
      packaging: ["25 kg plastic bag"],
    },
    {
      code: "LDPE",
      name: "Low-Density Polyethylene",
      description:
        "LDPE is a low-density polyethylene resin known for its flexibility, clarity, toughness and excellent moisture-barrier performance. Widely used in extrusion coating and lamination, it bonds readily to substrates such as aluminium foil, paper, nylon and other films, making it a preferred choice for flexible packaging and protective liner applications.",
      image: "/images/polymers/ldpe.webp",
      applications: [
        { app: "Extrusion lamination and extrusion coating for general use", char: "Very good neck-in performance" },
        { app: "Coating on substrates such as aluminium foil, nylon, PET, OPP and paper", char: "Good organoleptic (odour/taste-neutral) properties" },
        { app: "Food and non-food flexible packaging", char: "Good processability" },
        { app: "Moisture-barrier inner liners and protective films", char: "Good thickness control and edge stability" },
      ],
      physicalGroups: [
        {
          group: "Resin Properties",
          rows: [
            { property: "Melt Flow Rate", test: "ASTM D 1238 @ 190°C, 2.16 kg", value: "7.0", unit: "g/10 min" },
            { property: "Density", test: "ASTM D 1505", value: "0.920", unit: "g/cm³" },
            { property: "Melting Point", test: "ASTM D 2117", value: "107", unit: "°C" },
            { property: "Vicat Softening Point", test: "ASTM D 1525", value: "85", unit: "°C" },
          ],
        },
        {
          group: "Coating Property",
          rows: [
            { property: "Neck-in", test: "TPE Method", value: "5", unit: "cm" },
          ],
        },
      ],
      packaging: ["25 kg plastic bag"],
    },
    {
      code: "PS",
      name: "Polystyrene",
      description:
        "PS is a versatile, rigid thermoplastic prized for its clarity, dimensional stability, ease of processing and low cost. General-purpose (crystal) grades deliver high transparency and gloss, while impact-modified grades add toughness — making PS a preferred choice for packaging, disposables, and molded consumer and medical products.",
      image: "/images/polymers/ps.webp",
      applications: [
        { app: "Injection molding for cutlery, cups, jewelry & gift boxes and rigid housewares", char: "High rigidity and dimensional stability" },
        { app: "Extrusion and thermoforming for food packaging, dairy tubs and trays", char: "Excellent transparency and surface gloss (GPPS)" },
        { app: "Medical disposables such as petri dishes, test-tube holders and specimen jars", char: "Good processability across injection and extrusion" },
        { app: "Sheet and film for point-of-sale and protective packaging", char: "Good electrical insulation properties" },
        { app: "—", char: "Easily colored, printed and decorated" },
      ],
      physicalGroups: [
        {
          group: "Resin Properties (General-Purpose / Injection Grade)",
          rows: [
            { property: "Melt Flow Rate", test: "ASTM D 1238 @ 200°C, 5.0 kg", value: "8.0", unit: "g/10 min" },
            { property: "Density", test: "ASTM D 1505", value: "1.05", unit: "g/cm³" },
            { property: "Vicat Softening Point", test: "ASTM D 1525", value: "98", unit: "°C" },
          ],
        },
        {
          group: "Mechanical Property",
          rows: [
            { property: "Tensile Strength", test: "ASTM D 638", value: "45", unit: "MPa" },
          ],
        },
      ],
      technicalNote:
        "PS is an amorphous polymer — it softens over a temperature range rather than at a sharp melting point, so the Vicat softening point is used in place of a melting point.",
      packaging: ["25 kg plastic bag"],
    },
    {
      code: "PET",
      name: "Polyethylene Terephthalate",
      description:
        "PET is a strong, lightweight, semi-crystalline polyester valued for its clarity, excellent gas-barrier performance and food-contact safety. Bottle-grade (blow-molding) resins are graded chiefly by intrinsic viscosity (IV) and are the material of choice for beverage, food and personal-care packaging worldwide.",
      image: "/images/polymers/pet.webp",
      applications: [
        { app: "Stretch blow molding for water, CSD (carbonated soft drink) and edible-oil bottles", char: "Excellent clarity and gloss" },
        { app: "Preform and bottle production for cosmetics, pharmaceutical and FMCG packaging", char: "High tensile and impact strength" },
        { app: "Thermoforming for trays, clamshells and snack containers", char: "Good gas and moisture barrier (CO₂/O₂)" },
        { app: "Film and sheet for flexible and rigid packaging", char: "Food-contact safe and fully recyclable" },
        { app: "—", char: "Good dimensional stability" },
      ],
      physicalGroups: [
        {
          group: "Resin Properties (Bottle-Grade / Blow-Molding)",
          rows: [
            { property: "Intrinsic Viscosity (IV)", test: "ASTM D 4603", value: "0.80", unit: "dL/g" },
            { property: "Density", test: "ASTM D 1505", value: "1.40", unit: "g/cm³" },
            { property: "Melting Point", test: "ASTM D 3418", value: "250", unit: "°C" },
            { property: "Glass Transition Temp", test: "ASTM D 3418", value: "78", unit: "°C" },
          ],
        },
        {
          group: "Mechanical Property",
          rows: [
            { property: "Tensile Strength", test: "ASTM D 638", value: "55", unit: "MPa" },
          ],
        },
      ],
      technicalNote:
        "Bottle-grade PET is specified primarily by intrinsic viscosity (IV) — the key indicator of molecular weight and of bottle strength, stretch and processing behaviour.",
      packaging: ["25 kg plastic bag", "1050 kg packaging"],
    },
    {
      code: "PVC",
      name: "Polyvinyl Chloride",
      description:
        "PVC is one of the most widely used thermoplastics, supplied as a suspension resin (PVC-S) graded by K-value, an index of molecular weight. It is compounded with stabilizers, plasticizers and additives to produce both rigid and flexible end-products, offering excellent chemical resistance, inherent flame retardancy and strong cost efficiency across construction, electrical and packaging markets.",
      image: "/images/polymers/pvc.webp",
      applications: [
        { app: "Rigid: pipes, fittings, profiles, window frames and sheets", char: "Excellent chemical and corrosion resistance" },
        { app: "Flexible: wire & cable insulation, films, hoses and footwear", char: "Inherent flame retardancy" },
        { app: "Calendered films and sheets for packaging and signage", char: "Good mechanical strength in rigid grades" },
        { app: "Artificial leather, tubes and molded fittings", char: "Versatile rigid or flexible via compounding" },
        { app: "—", char: "Cost-effective, weatherable and durable" },
      ],
      physicalGroups: [
        {
          group: "Resin Properties (Suspension Grade, ~SG5 / K66–68)",
          rows: [
            { property: "K-Value", test: "ISO 1628-2", value: "66-68", unit: "—" },
            { property: "Apparent (Bulk) Density", test: "ASTM D 1895", value: "0.52", unit: "g/cm³" },
            { property: "Resin Density", test: "ASTM D 792", value: "1.40", unit: "g/cm³" },
            { property: "Vicat Softening Point (rigid compound)", test: "ASTM D 1525", value: "80", unit: "°C" },
          ],
        },
      ],
      technicalNote:
        "PVC is supplied as a resin powder graded by K-value and is amorphous — it is compounded and processed below a defined decomposition/softening range rather than melted at a fixed point. Final properties depend heavily on the compound formulation.",
      packaging: ["25 kg bag"],
    },
    {
      code: "EVA",
      name: "Ethylene Vinyl Acetate",
      description:
        "EVA is a flexible, rubber-like copolymer of ethylene and vinyl acetate. Its properties are governed by vinyl-acetate (VA) content and melt flow — higher VA increases flexibility, clarity and adhesion. EVA is widely used in foams and footwear, hot-melt adhesives, and solar-module encapsulant films.",
      image: "/images/polymers/eva.webp",
      applications: [
        { app: "Foaming and injection molding for shoe soles, midsoles and sports goods", char: "Excellent flexibility and softness, including at low temperature" },
        { app: "Hot-melt adhesives, coatings and sealants", char: "Good clarity and gloss" },
        { app: "Solar encapsulant (EVA film) for photovoltaic modules", char: "Strong adhesion and heat-sealability" },
        { app: "Film extrusion, compounding and flexible packaging", char: "Good environmental stress-crack resistance" },
        { app: "—", char: "Easily foamed, cross-linked and compounded" },
      ],
      physicalGroups: [
        {
          group: "Resin Properties (Typical ~18% VA Grade)",
          rows: [
            { property: "Vinyl Acetate (VA) Content", test: "ASTM D 5594", value: "18", unit: "%" },
            { property: "Melt Flow Rate", test: "ASTM D 1238 @ 190°C, 2.16 kg", value: "2.5", unit: "g/10 min" },
            { property: "Density", test: "ASTM D 1505", value: "0.938", unit: "g/cm³" },
            { property: "Melting Point", test: "ASTM D 3418", value: "88", unit: "°C" },
            { property: "Vicat Softening Point", test: "ASTM D 1525", value: "64", unit: "°C" },
          ],
        },
        {
          group: "Mechanical Property",
          rows: [
            { property: "Tensile Strength", test: "ASTM D 638", value: "18", unit: "MPa" },
          ],
        },
      ],
      technicalNote:
        "EVA properties vary directly with vinyl-acetate (VA) content — higher VA raises flexibility, clarity and adhesion while lowering melting point and stiffness. Grades are selected by VA% and MFR to suit foam, adhesive or encapsulant applications.",
      packaging: ["25 kg plastic bag"],
    },
  ],
};

// ---- News ----
export const news = [
  {
    id: 1,
    slug: "ruken-alazdehar-joins-intercem-dubai-2025",
    title: "Ruken Alazdehar joins INTERCEM Dubai 2025",
    date: "2025-04-18",
    excerpt:
      "Our leadership team represented Ruken Alazdehar at INTERCEM Dubai — meeting global cement and clinker producers and signing new multi-year offtake agreements.",
    image:
      "https://images.unsplash.com/photo-1606185540834-d6e7483ee1a4?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 2,
    slug: "new-gypsum-supply-corridor-from-oman",
    title: "New gypsum supply corridor opened from Oman",
    date: "2025-02-10",
    excerpt:
      "A new long-term agreement adds 240,000 tons / year of natural gypsum from Sohar, expanding our Middle East corridor for South Asian cement plants.",
    image:
      "https://images.unsplash.com/photo-1666219462105-2909c2d72d01?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 3,
    slug: "clinker-shipment-milestone",
    title: "1 million tons of clinker exported in 2024",
    date: "2025-01-04",
    excerpt:
      "Ruken Alazdehar crosses the 1 million ton clinker milestone in a single year, supplying cement plants across South Asia and Latin America.",
    image:
      "https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 4,
    slug: "port-leases-expanded-jebel-ali",
    title: "Expanded port-lease capacity at Jebel Ali",
    date: "2024-11-22",
    excerpt:
      "Additional offsite stockpile space leased at Jebel Ali, supporting faster stevedoring and door-to-door deliveries for coal and slag products.",
    image:
      "https://images.unsplash.com/photo-1617952739760-1dcae19a1d93?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: 5,
    slug: "iron-slag-abrasive-launch",
    title: "GBFS slag launch for cement additive applications",
    date: "2024-09-09",
    excerpt:
      "A new processed GBFS slag grade is now available for sustainable cement production and structural concrete applications worldwide.",
    image:
      "https://images.pexels.com/photos/5125104/pexels-photo-5125104.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: 6,
    slug: "petcoke-corridor-south-america",
    title: "New petcoke corridor from South America",
    date: "2024-07-14",
    excerpt:
      "Strategic offtake from South American refineries strengthens our solid-fuels portfolio for cement clients in EMEA and APAC.",
    image:
      "https://images.pexels.com/photos/60008/brown-coal-energy-garzweiler-bucket-wheel-excavators-60008.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const partners = [
  "Cementos del Sur",
  "Atlas Bauxite Co.",
  "Sohar Gypsum",
  "PortLogix Dubai",
  "AsiaClinker Group",
  "Trinidad Iron Works",
  "NordicCoal",
  "Andes Petcoke",
  "BlueWave Shipping",
  "Persian Gulf Minerals",
  "GreenAggregates",
  "Suez Trade Lines",
];

export const heroImages = {
  main: "/images/hero-1.webp",
  about: "/images/bulk-carrier-1.webp",
  contact: "/images/contact-hero.webp",
  news: "/images/news-hero.webp",
  ceo: "https://images.unsplash.com/photo-1568621422837-a343133e2bb9?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const countriesList = [
  "United Arab Emirates", "India", "China", "Pakistan", "Saudi Arabia", "Egypt",
  "Oman", "Turkey", "Spain", "Mexico", "USA", "Brazil", "Argentina", "Trinidad and Tobago",
  "South Africa", "Bangladesh", "Sri Lanka", "Indonesia", "Vietnam", "Philippines",
  "Germany", "France", "United Kingdom", "Italy", "Australia", "Japan", "South Korea",
  "Singapore", "Hong Kong", "Qatar", "Bahrain", "Kuwait", "Thailand",
];

export const phonePrefixes = [
  { code: "+971", country: "UAE" },
  { code: "+1", country: "USA" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+86", country: "China" },
  { code: "+92", country: "Pakistan" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+20", country: "Egypt" },
  { code: "+968", country: "Oman" },
  { code: "+90", country: "Turkey" },
  { code: "+34", country: "Spain" },
  { code: "+52", country: "Mexico" },
  { code: "+55", country: "Brazil" },
  { code: "+27", country: "South Africa" },
  { code: "+880", country: "Bangladesh" },
  { code: "+62", country: "Indonesia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+39", country: "Italy" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+82", country: "South Korea" },
  { code: "+65", country: "Singapore" },
  { code: "+66", country: "Thailand" },
  { code: "+84", country: "Vietnam" },
];

// ---- Form dropdown values ----
export const productDropdown = [
  "Portland Cement Clinker",
  "Limestone (Cement & Construction Grade)",
  "Natural Gypsum",
  "Slag (GBFS / GGBFS)",
  "Fly Ash",
  "Petroleum Products / Bitumen",
  "Commodity Plastic Resin",
  "Others / General Inquiry",
];

export const incotermsOptions = ["CFR", "CIF", "FOB"];

export const paymentTermsOptions = [
  "L/C at Sight",
  "Usance L/C",
  "CAD (Cash Against Documents)",
  "Advance TT",
  "Others",
];

export const supplierProductsOffered = [
  "Portland Cement Clinker",
  "Limestone",
  "Natural Gypsum",
  "Slag (GBFS / GGBFS)",
  "Fly Ash",
  "Aggregates / Crushed Stone",
  "Cement (Bulk / Bag)",
  "Coal",
  "Minerals (Aluminum / Iron Ore / Bauxites)",
  "Chemicals",
  "Petroleum Products",
  "Commodity Plastic Resin",
];

export const supplierCategoryOptions = ["Quarry Owner", "Manufacturer", "Trader", "Wholesaler"];

// ---- Interactive Material Hub (Homepage) ----
export const materialHub = [
  {
    name: "Natural Gypsum",
    image: "/images/product-gypsum.jpg",
    to: "/products/category-a-cement-raw-material-products#Gypsum",
    position: "tl",
  },
  {
    name: "Portland Cement Clinker",
    image: "/images/product-clinker-hq.jpg",
    to: "/products/category-a-cement-raw-material-products#Clinker",
    position: "tr",
  },
  {
    name: "Limestone",
    image: "/images/product-limestone-small.jpg",
    to: "/products/category-a-cement-raw-material-products#" + encodeURIComponent("Limestone (Cement & Construction Grade)"),
    position: "bl",
  },
  {
    name: "GBFS / GGBFS Slag",
    image: "/images/product-slag.webp",
    to: "/products/category-a-cement-raw-material-products#" + encodeURIComponent("Slag (GBFS / GGBFS)"),
    position: "br",
  },
];
